var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsdt = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#2AAF86"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.03 21.741v-.002c-.114.008-.702.042-2.011.042-1.047 0-1.781-.03-2.041-.042v.002c-4.026-.177-7.03-.877-7.03-1.717 0-.838 3.006-1.54 7.03-1.718v2.738c.262.019 1.017.064 2.06.064 1.25 0 1.876-.053 1.992-.064V18.31c4.018.18 7.013.88 7.013 1.717 0 .838-2.997 1.538-7.013 1.718m0-3.719v-2.448h5.606v-3.735H12.375v3.734h5.605v2.45c-4.556.209-7.98 1.11-7.98 2.191 0 1.082 3.427 1.983 7.98 2.195v7.85h4.053v-7.85C26.58 22.202 30 21.302 30 20.22c0-1.079-3.419-1.982-7.967-2.192",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsdt);
export { ForwardRef as ReactComponent };